import "chartkick/chart.js"
import "bootstrap"
import "./favorites"
import "./gtm_events"
import "./clipboard"
import "./bootstrap_tooltips"
import "./sticky_cta"
import "./view_toggle_sticky"

// Prefecture dropdown handler
window.addEventListener('load', () => {
  const select = document.querySelector('.stores-index-search__form-select')
  if (select) {
    select.addEventListener('change', function() {
      location.href = `/stores/prefecture/${this.value}`
    })
  }
})

import "./sort_filter"
import "./compare_history"
import "./freshness"
import "./geo_map"
